"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import Combobox_module_default from "../Combobox.module.mjs";
import { useComboboxContext } from "../Combobox.context.mjs";
import { useEffect } from "react";
import { useId as useId$1 } from "@mantine/hooks";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Combobox/ComboboxOptions/ComboboxOptions.tsx
const ComboboxOptions = factory((_props) => {
	const { classNames, className, style, styles, id, onMouseDown, labelledBy, ...others } = useProps("ComboboxOptions", null, _props);
	const ctx = useComboboxContext();
	const _id = useId$1(id);
	useEffect(() => {
		ctx.store.setListId(_id);
	}, [_id]);
	return /* @__PURE__ */ jsx(Box, {
		...ctx.getStyles("options", {
			className,
			style,
			classNames,
			styles
		}),
		...others,
		id: _id,
		role: "listbox",
		"aria-labelledby": labelledBy,
		onMouseDown: (event) => {
			event.preventDefault();
			onMouseDown?.(event);
		}
	});
});
ComboboxOptions.classes = Combobox_module_default;
ComboboxOptions.displayName = "@mantine/core/ComboboxOptions";
//#endregion
export { ComboboxOptions };

//# sourceMappingURL=ComboboxOptions.mjs.map